import styles from "./StatisticsReservationDialog.module.scss";
import { CommissionCategoryLabels } from "../../../common/labels";
import { dateUtility } from "../../../common/infrastructure/utilities/dateUtility";
import { StatisticsDialogKeyValueItem } from "./StatisticsDialogKeyValueItem";
import { Tag } from "../../../common/components/common/Tag/Tag";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { constructUserHref } from "../../../common/infrastructure/routes/routePaths";
import { CommissionCategory } from "../../../common/enums";

export interface IStatisticsInstructorVisitModel {
  dateTime: Date;
  pricePaidInEur?: number | null;
  commissionCategory?: CommissionCategory | null;
  commissionPercent?: number | null;
  commissionAmountInEur?: number | null;
}

export interface IStatisticsInstructorItemModel {
  userId: number;
  userName: string;
  numberOfOccurances: number;
  totalRevenue: number;
  totalCommission: number;
  visits: IStatisticsInstructorVisitModel[];
}

interface IStatisticsInstructorDialogProps {
  item: IStatisticsInstructorItemModel;
}

export const StatisticsInstructorDialog = ({
  item,
}: IStatisticsInstructorDialogProps) => {
  const navigate = useNavigate();

  const onClick = () => {
    if (!item.userId) {
      return;
    }

    const link = constructUserHref(item.userId);
    navigate(link);
  };

  return (
    <div className={styles.root} onClick={onClick}>
      <div className={styles.root_header}>
        <div className={styles.root_header_left}>
          <h5>
            {item.userName} <span>(#{item.userId})</span>
          </h5>
        </div>
        <div className={styles.root_header_right}>
          <div>
            <Tag
              className={classNames(styles.root_header_right_tag)}
              label={
                item.numberOfOccurances === 1
                  ? `${item.numberOfOccurances} тренировка`
                  : `${item.numberOfOccurances} тренировки`
              }
            />
          </div>
        </div>
      </div>

      {item.visits.length > 0 && (
        <div className={styles.root_visits}>
          <div className={styles.root_visits_title}>Посещения</div>

          <div className={styles.root_visits_head}>
            <span>Дата</span>
            <span>Тип</span>
            <span>Сума</span>
            <span>%</span>
            <span>Комисионна</span>
          </div>

          {item.visits.map((visit, index) => (
            <div className={styles.root_visits_row} key={index}>
              <span className={styles.root_visits_date}>
                {dateUtility.formatDateTime(visit.dateTime)}
              </span>
              <span className={styles.root_visits_category}>
                {visit.commissionCategory !== null &&
                visit.commissionCategory !== undefined
                  ? CommissionCategoryLabels[
                      visit.commissionCategory as CommissionCategory
                    ]
                  : "—"}
              </span>
              <span className={styles.root_visits_price}>
                {visit.pricePaidInEur !== null &&
                visit.pricePaidInEur !== undefined
                  ? `€ ${visit.pricePaidInEur.toFixed(2)}`
                  : "—"}
              </span>
              <span className={styles.root_visits_percent}>
                {visit.commissionPercent !== null &&
                visit.commissionPercent !== undefined
                  ? `${visit.commissionPercent}%`
                  : "—"}
              </span>
              <span className={styles.root_visits_amount}>
                {visit.commissionAmountInEur !== null &&
                visit.commissionAmountInEur !== undefined
                  ? `€ ${visit.commissionAmountInEur.toFixed(2)}`
                  : "—"}
              </span>
            </div>
          ))}
        </div>
      )}

      <div className={styles.root_content}>
        <StatisticsDialogKeyValueItem
          name={"ОБЩ ГЕНЕРИРАН ОБОРОТ"}
          value={
            !!item.totalRevenue ? `€ ${item.totalRevenue.toFixed(2)}` : "N/A"
          }
        />
        <StatisticsDialogKeyValueItem
          name={"ОБЩА СПЕЧЕЛЕНА КОМИСИОННА"}
          value={
            !!item.totalCommission
              ? `€ ${item.totalCommission.toFixed(2)}`
              : "€ 0.00"
          }
        />
      </div>
    </div>
  );
};
